export default __webpack_public_path__ + "static/media/ethereum.c1650171.svg";